import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    FormControl, InputLabel, Select, MenuItem, Grid, TextField, Box, Button, Tooltip,
    FormControlLabel, Radio, RadioGroup, IconButton
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SearchIcon from "@mui/icons-material/Search";
import 'react-phone-input-2/lib/style.css';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../index.css';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TableHead from '@mui/material/TableHead';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import {
    Typography, Stepper, Step,
    StepLabel, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Paper, InputAdornment
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import {
    KeyboardArrowLeft as KeyboardArrowLeftIcon,
    NavigateNext as NavigateNextIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    CancelPresentation as CancelPresentationIcon,
    LocalPrintshop as PrintIcon,
} from "@mui/icons-material";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import BookingHistory from './BookingHistory';
import OutlinedInput from '@mui/material/OutlinedInput';
import Flag from './Flag'
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import BReport from '../../../atoms/ReportFolder/BReport2';
import BedDetails from './BedAvilableDetails'
import CrudButtons from '../../../../src/GlobalFunction/CrudButtons'
import axiosInstance from '../../../lib/axios';
import axiosInstanceForPG from '../../../lib/axiosFormPG';
import checkAndLock from '../../../GlobalFunction/checkAndLock';
import UnLock from '../../../GlobalFunction/UnLock';
import BillingDetailsModal from '../BConfirmation/ACCGenerateDetailsModal';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import HistoryIcon from '@mui/icons-material/History';
import PaymentsIcon from '@mui/icons-material/Payments';
import CancelIcon from '@mui/icons-material/Cancel';
import RestoreIcon from '@mui/icons-material/Restore';
import RoomSelection from '../../RoomSelection/RoomSelection';
import { selectGatewayType } from '../../../redux/propertySlice';
import { useSelector } from 'react-redux';

const BASE_COLUMNS = [
    { id: 'WingName', label: 'Wing', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'FloorName', label: 'Floor', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'RoomTypeName', label: 'Type', minWidth: 60, maxWidth: 60, width: 60 },
    { id: 'RoomViewNAme', label: 'View', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'RoomBedTypeName', label: 'BType', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'RoombedName', label: 'BedNo', minWidth: 30, maxWidth: 30, width: 30 },
    { id: 'BedRent', label: 'Rent', minWidth: 30, maxWidth: 30, width: 30 },
];

const Renewbooking = () => {
    const { register, setValue, reset, watch } = useForm();
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [BookId, setBookId] = useState(-1);
    const [Mode, setMode] = useState("add");
    const [PlanDrp, setPlanDrp] = useState([]);
    const [TransactionData, setTransactionData] = useState([]);
    const [RoomBedId, setRoomBedId] = useState(-1);
    const [ResidentData, setResidentData] = useState({});
    const [SelectedRow, setSelectedRow] = useState({});
    const [PropertyDrp, setPropertyDrp] = useState([]);
    const [TopUpDrp, setTopUpDrp] = useState([]);
    const [PromoCodeID, setPromoCodeID] = useState(-1);
    const [HistoryData, setHistoryData] = useState([]);
    const [openConfirmDialog, setopenConfirmDialog] = useState(false);
    const [MobileNo, setMobileNo] = useState('');
    const [DateFrom, setDateFrom] = React.useState(dayjs(new Date));
    const [DateTo, setDateTo] = React.useState(dayjs('MM-DD-YYYY'));
    const [todayDate, setTodayDate] = useState(moment(new Date()).format("MM-DD-YYYY"));
    const [ResidentId, setResidentId] = useState(-1);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [searchTerms, setSearchTerms] = useState({});
    const [rows, setRows] = useState([]);
    const [isDepositPaid, setIsDepositPaid] = useState(false);
    const [AllDisUnable, setAllDisUnable] = useState(true);
    const [selectedImage, setselectedImage] = useState(Flag);
    const [RoomPlanId, setRoomPlanId] = useState(-1);
    const navigate = useNavigate();
    const [OpenHistoryTable, setOpenHistoryTable] = useState(false);
    const location = useLocation();
    const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
    const [OpenHistoryTableDialog1, setOpenHistoryTableDialog1] = useState(false);
    const [OpenDForDelete, setOpenDForDelete] = useState(false);
    const [OpenDForCancel, setOpenDForCancel] = useState(false);
    const [MobDigit, setMobDigit] = useState(10);
    const [TransPlanDrp, setTransPlanDrp] = useState([]);
    const [MessPlanDrp, setMessPlanDrp] = useState([]);
    const [OpenLoader, setOpenLoader] = useState(false);
    const [selectedBedData, setSelectedBedData] = useState(null);
    const [tableColumns, setTableColumns] = useState(BASE_COLUMNS);
    const [Loader, setLoader] = useState(false);
    const [openBillingModal, setOpenBillingModal] = useState(false);
    const [billingDetails, setBillingDetails] = useState(null);
    const [PlanDataState, setPlanDataState] = useState(null);
    const [PayAdvice, setPayAdvice] = useState(null);
    const [PayGenerate, setPayGenerate] = useState(null);
    const [PendingDetails, setPendingDetails] = useState(null);
    const [fontSize, setFontSize] = useState('1rem');
    // const permissions = useModulePermissions("Booking");
    const contentRef = useRef(null);
    const baseUrl = window.location.origin;
    const [openRenewalPopup, setOpenRenewalPopup] = useState(false);
    const [renewalData, setRenewalData] = useState(null);
    const [lastBookId, setLastBookId] = useState('')
    const [unit, setUnit] = useState('')
    const [bedId, setBedId] = useState('')
    const [oldBedId, setOldBedId] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pytAdvNo, setPytAdvNo] = useState('')
    const [pytAdvId, setPytAdvId] = useState('')
    const [isSubmitted, setIsSubmitted] = useState(false);
    const gatewayType = useSelector(selectGatewayType);
    const handlePrint = useReactToPrint({ contentRef });

    useEffect(() => {
        const fetchData = async () => {
            console.log("Location state:", location.state);
            const urlParams = new URLSearchParams(window.location.search);
            const bookIdFromUrl = urlParams.get('bookId');
            await fetchPropertyData();
            await fetchTransPlanDrp();
            await fetchMessPlanDrp();

            if (location.state) {
                setAllDisUnable(false);
                let BookId = location.state.BookId;
                setBookId(location.state.BookId);
                await fetchTransactionData(BookId, "R");
                if (location.state.fromAccGen && location.state.isSubmitted) {
                    setIsSubmitted(true);
                } else {
                    setIsSubmitted(false);
                }
            } else if (bookIdFromUrl) {
                setAllDisUnable(false);
                setBookId(parseInt(bookIdFromUrl));
                await fetchTransactionData(parseInt(bookIdFromUrl), "R");
                setIsSubmitted(true);
            }
            else {
                setMode("add");
                setAllDisUnable(true);
                // setIsSubmitted(false);
            }
            // await fetchRoomNoData();
            // await fetchRoomBedNoData();
        }

        fetchData();
    }, []);

    const mobileNoFromQuery = new URLSearchParams(window.location.search).get('MobileNo');

    useEffect(() => {
        if (mobileNoFromQuery && mobileNoFromQuery.length === MobDigit) {
            setValue('MobileNo', mobileNoFromQuery, { shouldValidate: true, shouldDirty: true });
            setMobileNo(mobileNoFromQuery);
            handleMobileChange({ target: { value: mobileNoFromQuery } }, "add", null);
        }
    }, [mobileNoFromQuery, setValue]);

    useEffect(() => {
        if (tableColumns.length >= (parseInt(watch("Duration")) + 8) && rows.length > 0) {
            setTimeout(() => {
                setLoader(false);
            }, 1000);
        }
    }, [tableColumns, rows]);

    useEffect(() => {
        setValue('BookDtFrom', todayDate);
        setValue('BookDt', todayDate);
    }, [todayDate]);

    const fetchFreshResidentData = async (mobileNo) => {
        try {
            const response = await axiosInstance.post(`ResidentMst/RetriveResidentMstAll`,
                { ResidentId: 1, Flag: "M", Mobile: mobileNo.trim() },
            );

            if (response.data.Status === 0 && response.data.Data.MstResidentList[0]) {
                const { FirstName, Email, LastName, ResidentId, CouponNo, DiscType, DiscountAmt, DiscAmt, CouponId, ResidentName } = response.data.Data.MstResidentList[0];

                setValue("FirstName", FirstName);
                setValue("Email", Email);
                setValue("LastName", LastName);
                setValue("ResidentName", ResidentName);

                if (CouponNo && CouponNo !== "") {
                    setValue("CouponNo", CouponNo);
                    setValue("DiscType", DiscType);
                    setValue("DiscountAmt", DiscountAmt);
                    setValue("DiscAmt", DiscAmt);
                    setValue("AMTDISCOUNT", DiscAmt);
                    setValue("CouponId", CouponId);
                } else {
                    setValue("CouponNo", "");
                    setValue("DiscType", "");
                    setValue("DiscountAmt", 0);
                    setValue("DiscAmt", 0);
                    setValue("AMTDISCOUNT", 0);
                    setValue("CouponId", "");
                }
                setResidentData(response.data.Data.MstResidentList[0]);
                setResidentId(ResidentId);
            }
        } catch (error) {
            console.error('Error fetching fresh resident data:', error);
        }
    };

    useEffect(() => {
        const loadData = async () => {
            if (TransactionData.length > 0 && Mode != "add") {
                const obj = watch();
                for (let key in obj) {
                    if (TransactionData[0].hasOwnProperty(key)) {
                        if (!['CouponNo', 'DiscType', 'DiscAmt', 'AMTDISCOUNT', 'CouponId'].includes(key)) {
                            setValue(key, TransactionData[0][key]);
                        }
                    } else {
                        setValue(key, "");
                    }
                }
                const apiBookingType = TransactionData[0].BookingType === "R" ? "renewal" : "new";
                setValue("bookingType", apiBookingType);
                setValue("PlanName", TransactionData[0].PlanName);
                setValue("PropName", TransactionData[0].PropName);
                setValue("PytAdvId", TransactionData[0].PytAdvId);
                setValue("PytAdvNo", TransactionData[0].PytAdvNo);
                setValue("BookStatus", TransactionData[0].BookStatus);
                setValue("CreatedName", TransactionData[0].CreatedName);
                setValue("UpdatedName", TransactionData[0].UpdatedName);
                setResidentId(TransactionData[0].ResidentId);
                setValue("Addr", TransactionData[0].Addr);
                setValue("AMTDISCOUNT", TransactionData[0].DiscountAmt);
                setValue("CouponId", TransactionData[0].CouponId);
                handlePropertyWiseImage(TransactionData[0]['PropId']);
                // handleMobileChange({ target: { value: TransactionData[0].MobileNo } }, "view");
                if (TransactionData[0].MobileNo && TransactionData[0].MobileNo.length === MobDigit) {
                    await fetchFreshResidentData(TransactionData[0].MobileNo);
                }
                let getObj = TransPlanDrp.find(obj => obj.TransPlanID === TransactionData[0].TransPlanId);
                if (getObj) {
                    setValue("TrspChrg", getObj.Amount);
                    setValue("TransPlanId", getObj.TransPlanID);

                }
                let getObjM = MessPlanDrp.find(obj => obj.MessPlanID === TransactionData[0].MessPlanId);
                if (getObjM) {
                    setValue("MessChrg", getObjM.Amount);
                    setValue("MessPlanId", getObjM.MessPlanID);
                }
                setTmt();
                const fetchingData = async () => {
                    await fetchPlanDrpData();
                    await fetchRoomSelectionData(TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, "Retreive");
                    await fetchTopUpData(TransactionData[0].RoomTypeId, "view");
                    await fetchHistoryData(TransactionData[0]['ResidentId'])
                    // await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
                }
                fetchingData()
            } else if (Mode === "add") {
                handleAddClick();
            }
        }
        loadData()
    }, [TransactionData, Mode]);

    useEffect(() => {
        const handleFetchData = (event) => {
            if (event.data?.action === "fetchBedData") {
                const savedBedData = localStorage.getItem("selectedBedData");
                if (savedBedData) {
                    try {
                        const bedData = JSON.parse(savedBedData);
                        setValue("WingName", bedData.WingName || "");
                        setValue("FloorName", bedData.FloorName || "");
                        setValue("RoomTypeName", bedData.RoomTypeName || "");
                        setValue("RoomViewNAme", bedData.RoomViewNAme || "");
                        setValue("RoomBedTypeName", bedData.RoomBedTypeName || "");
                        setValue("RoombedName", bedData.RoombedName || "");
                        setValue("BedRent", bedData.BedRent || 0);
                        localStorage.removeItem("selectedBedData");
                    } catch (error) {
                        console.error("Error parsing bed data from localStorage:", error);
                    }
                }
            }
        };

        window.addEventListener("message", handleFetchData);
        return () => {
            window.removeEventListener("message", handleFetchData);
        };
    }, []);

    useEffect(() => {
        const updateFontSize = () => {
            const width = window.innerWidth;
            if (width <= 600) {
                setFontSize('0.rem');
            } else if (width <= 960) {
                setFontSize('1rem');
            } else {
                setFontSize('1.125rem');
            }
        };
        updateFontSize();
        window.addEventListener('resize', updateFontSize);
        return () => window.removeEventListener('resize', updateFontSize);
    }, []);

    const handlePropertyWiseImage = (value) => {
        let obj = PropertyDrp.find(objD => objD.Id === value);
        obj ? setselectedImage(obj.CountryIcon) : setselectedImage("");
        obj && setMobDigit(obj.MobDigit);
    }

    const fetchRoomSelectionData = async (date, date1, ByMode) => {
        date = moment(new Date(date)).format("YYYY-MM-DD");
        const formattedDate = moment(new Date(date1)).format("YYYY-MM-DD");
        if (ByMode === "Retreive") {
            try {
                const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
                    BookFromDt: date,
                    BookToDt: formattedDate,
                    PropId: watch('PropId'),
                    Flag: "",
                    RoomBedId: TransactionData[0].RoomBedId,
                });

                if (response.data.Status === 0) {
                    // handleRowDoubleClick(response.data.Data[0], "view");
                    let row = response.data.Data[0];
                    const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName } = row;
                    const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName };
                    for (let key in obj) {
                        setValue(key, row[key]);
                    }
                    setSelectedRow(row);
                    setSelectedBedData(row);
                    // setValueOfTable(response.data.Data);  
                } else {
                    setRows([]);
                }
            } catch (error) {
                console.error('Error fetching company data:', error);
            }
        } else {
            // FetchBedCalender(date, formattedDate);
        }
        setPage(0);
    };

    const fetchBedData = async () => {
        const BookFromDt = moment().format("YYYY-MM-DD");
        const BookToDt = moment().add(1, "days").format("YYYY-MM-DD");

        try {
            const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
                BookFromDt,
                BookToDt,
                PropId: watch('PropId'),
                Flag: "Data",
                RoomBedId: selectedBedData?.RoomBedId || 0,
            });

            if (response.data.Status === 0) {
                setRows(response.data.Data);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchTransactionData = async (BookId, Flag) => {
        try {
            const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`, {
                BookId,
                Flag,
                CreatedBy: UserId
            },);
            if (response.data.Status === 0) {
                if (Flag === "D") {
                    toast.success(response.data.Message, { autoClose: 1000 });
                    fetchTransactionData(BookId, "L");
                    return;
                }
                let Data = response.data.Data != null ? response.data.Data : [];
                setTransactionData(Data);
                console.log("TransactionData", Data)
                const pytAdvNo = Data[0]?.PytAdvNo || null;
                const pytAdvId = Data[0]?.PytAdvId || null;
                setPytAdvNo(pytAdvNo);
                setPytAdvId(pytAdvId);
                console.log('Datammmm', Data)
                setLastBookId(response.data.Data[0].BookId);
                setBedId(response.data.Data[0].RoomBedId)
                setUnit(response.data.Data[0].RoombedName)
                setOldBedId(response.data.Data[0].RoomBedId)
                // setPropId(response.data.Data[0].PropId)
                const apiBookingType = Data[0].BookingType === "R" ? "renewal" : "new";
                setValue("bookingType", apiBookingType);
                setValue("PytAdvId", response.data.Data[0].PytAdvId);
                setMode("view");
                let Column = [...BASE_COLUMNS, { id: 'action', label: 'Action', minWidth: 30 }];
                setTableColumns(Column);
            } else {
                if (Flag != "D") {
                    setBookId(-1);
                    Mode === "view" ? setMode("add") : handleAddClick();
                }
                toast.info(response.data.Message);

            }
        } catch (error) {
            console.error('Error fetching Transaction  data:', error);
        }
    }

    const fetchPropertyData = async () => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`,
                { Flag, UserId },
            );
            if (response.data.Status === 0) {
                setPropertyDrp(response.data.Data);
                setValue("Name", response.data.Data[0].Name);
                fetchPlanDrpData();
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const fetchTransPlanDrp = async () => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(`MstTransPlan/getMstTransPlandrp`,
                { Flag, UserId },
            );
            if (response.data.Status === 0) {
                setTransPlanDrp(response.data.Data);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const fetchMessPlanDrp = async () => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(`MstMessPlan/getMstMessPlandrp`,
                { Flag, UserId },
            );

            if (response.data.Status === 0) {
                setMessPlanDrp(response.data.Data);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const fetchPlanDrpData = async () => {
        const Flag = Mode === "add" ? "" : "R";
        try {
            const response = await axiosInstance.post(`MstRoomPlan/getMstRoomPlandrp`,
                { Flag, PropId: watch("PropId") },
            );

            if (response.data.Status === 0) {
                setPlanDrp(response.data.Data);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const handleMobileChange = async (e, ByFlag, value = null) => {
        const newPhone = value !== null ? value : e.target?.value?.trim();
        setValue('MobileNo', newPhone);
        // if (watch("bookingType") === "renewal") {
        //     await fetchRenewalData(newPhone);
        // }
        if (newPhone && newPhone.length === MobDigit) {
            setMobileNo(newPhone);
            let num = newPhone;
            try {
                const response = await axiosInstance.post(`ResidentMst/RetriveResidentMstAll`,
                    { ResidentId: 1, Flag: "M", Mobile: num.trim() },
                );

                if (response.data.Status === 0 && response.data.Data.MstResidentList[0]) {
                    const { FirstName, Email, LastName, ResidentId, CouponNo, DiscType, DiscountAmt, DiscAmt, CouponId, ResidentName } = response.data.Data.MstResidentList[0];
                    if (Mode === "add") {
                        try {

                            const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
                                BookFromDt: "07/11/2024",
                                BookToDt: "11/30/2024",
                                PropId: 0,
                                RoomId: 0,
                                RoomTypeId: 1,
                                Flag: "RE",
                                MobileNo: num,
                                ResidentId: ResidentId,
                            });
                            if (response.data.Status === 1) {
                                const bookNo = response.data.Data[0].BookNo || '';
                                toast.info(`Your Booking is Already Exits on this Number, Please Confirm Your Booking (Booking No : ${bookNo})...`);
                                setMode("add");
                                setAllDisUnable(true);
                                setHistoryData([]);
                                return
                            }
                        } catch (error) {
                            toast.error('Error fetching resident data');
                        }
                    }

                    let obj = { FirstName, Email, LastName, CouponNo, DiscType, DiscountAmt, DiscAmt, CouponId, ResidentName };
                    setValue("FirstName", obj["FirstName"]);
                    setValue("Email", obj["Email"]);
                    setValue("LastName", obj["LastName"]);
                    setValue("ResidentName", obj["ResidentName"]);
                    if (CouponNo === "") {
                        setValue("FirstName", obj["FirstName"])
                        setValue("Email", obj["Email"])
                        setValue("LastName", obj["LastName"])
                        setValue("ResidentName", obj["ResidentName"])
                        setValue("CouponNo", "");
                        setValue("DiscType", "");
                        setValue("DiscountAmt", 0);
                        setValue("DiscAmt", 0);
                        setValue("CouponId", "");
                    } else {
                        for (let key in obj) {

                            if (ByFlag === "add") {
                                setValue(key, obj[key]);
                            } else if (key != "DiscAmt") {
                                setValue(key, obj[key]);
                            }
                        }
                    }
                    setValue("AMTDISCOUNT", obj["DiscAmt"]);
                    setValue('MobileNo', num);
                    setResidentData(response.data.Data.MstResidentList[0]);
                    fetchHistoryData(ResidentId);
                    setResidentId(ResidentId);
                    return;
                } else {
                    setopenConfirmDialog(true);
                    setValue('MobileNo', num);
                }
            } catch (error) {
                toast.error('Error fetching resident data');
            }
        }

        let obj = {
            FirstName: '',
            Email: '',
            LastName: '',
            CouponNo: '',
            CouponId: '',
            DiscType: '',
            DiscAmt: 0
        };
        for (let key in obj) {
            setValue(key, obj[key]);
        }
        setResidentId(-1);
        setHistoryData([]);
        // setValue('Duration', '');
        // setopenConfirmDialog(true);
    };

    const fetchHistoryData = async (ResidentId) => {
        try {
            const response = await axiosInstance.post(`ResidentHis/GetResidentHistory`,
                { ResidentId },
            );
            if (response.data.Status === 0) {
                setHistoryData(response.data.Data);
            } else {
                setHistoryData([]);
            }
        } catch (error) {
            toast.error('Error fetching resident data');
        }
    }

    useEffect(() => {
        if (watch('Duration') && watch('BookDtFrom')) {
            handlePropDurationChange('BookDtFrom');
        }
    }, [watch('BookDtFrom')]);

    const handlePropDurationChange = (name, value = String(watch('Duration'))) => {
        if (!watch('Duration') || !watch('BookDtFrom')) return;

        const startDate = dayjs(watch('BookDtFrom'));

        let endDate;
        if (value.includes(".")) {
            const [months, days] = value.split(".").map(Number);
            endDate = startDate.add(months, 'month').add(days, 'day');
        } else {
            // Handle full months
            endDate = startDate.add(Number(value), 'month');
        }

        const formattedEndDate = endDate.format('YYYY-MM-DD');

        setValue('BookUpToDt', formattedEndDate);
        setValue('CheckoutDt', formattedEndDate);
        setBillFunc();
        // fetchRoomSelectionData(watch('BookDtFrom'), formattedEndDate, "Insert");
    }

    const setBillFunc = () => {
        const date = new Date(watch('CheckoutDt'));
        const day = date.getDate();
        day <= 15 ? setValue("BillCycle", "F") : setValue("BillCycle", "S");
    }

    const handleCheckoutDateChange = (e) => {
        const { name, value } = e.target;
        setValue(name, value);
        setBillFunc();
    }

    const handlePropertyChange = (e) => {
        const { name, value } = e.target;
        setValue(name, value);
        setLoader(true);
        if (name === "Duration" || name == "BookDtFrom") {

            if ((name === "Duration" && watch("CouponNo") != "") && (watch("DiscType") === "F" || watch("DiscType") === "M")) {
                if (watch("DiscType") === "F") {
                    setValue("DiscAmt", watch("AMTDISCOUNT"));
                } else if (watch("DiscType") === "M") {
                    setValue("DiscAmt", watch("AMTDISCOUNT") * watch("Duration"));
                    setValue("DiscountAmt", watch("AMTDISCOUNT"));
                }

            }
            setValue("AdvcRcble", 0);
            setTmt();
            handlePropDurationChange(name, value);

        } else if (name === 'PropId') {
            fetchPlanDrpData(value);
            handlePropDurationChange(name);
            handlePropertyWiseImage(value);
            let obj = PropertyDrp.find(Iobj => Iobj.Id === value);

            if (obj) {
                setValue("Name", obj.Name);
            }
            // setValue('Duration', '');
            // setValue('BookUpToDt', "");
            setValue("RoomPlanId", '');

            const { PlanTenur, FreeMonth, LastAdjMonths, IncRentPerc, TotalInstall, TotalRent, DepositAmt } = watch()
            const new1obj = {
                PlanTenur,
                FreeMonth,
                LastAdjMonths,
                IncRentPerc,
                TotalInstall,
                DepositAmt
            }
            for (let key in new1obj) {
                setValue(key, 0);
            }
        }

        const { WingName,
            FloorName,
            RoomTypeName,
            RoomViewNAme,
            RoomBedTypeName,
            RoombedName, BedRent, TotalRent, NetAmt,
            MonthlyAmt,
            AdvcRcble } = watch();
        const newobj = {
            WingName,
            FloorName,
            RoomTypeName,
            RoomViewNAme,
            RoomBedTypeName,
            RoombedName,
            BedRent, TotalRent, NetAmt,
            MonthlyAmt,
            AdvcRcble
        }
        for (let key in newobj) {
            key !== "TotalRent" ? setValue(key, '') : setValue(key, 0);
        }
        setRows([]);
        setSelectedRow({});
    };

    const resetFunc = () => {

        reset({
            "PropId": '',
            "BookDtFrom": moment(todayDate).format("yyyy-MM-DD"),
            "BookDt": moment(todayDate).format("yyyy-MM-DD"),
            "BookNo": "",
            "FirstName": "",
            "LastName": "",
            "Email": "",
            "BookRef": "",
            "Duration": "",
            "BookUpToDt": "",
            "CheckoutDt": "",
            "WingName": "",
            "FloorName": "",
            "RoomTypeName": "",
            "RoomViewNAme": "",
            "RoomBedTypeName": "",
            "ResidentName": "",
            "RoombedName": "",
            "RoomPlanId": "",
            "PromoCodeName": "",
            "PromoDiscAmt": "",
            "BookRemark": "",
            "MobileNo": "",
            "DiscType": "",
            "DiscountAmt": 0,
            "TotalRent": 0,
            "AdvcRcble": 0,
            // "DepositeAmt": 0,
            "DepositAmt": 0,
            "DiscAmt": 0,
            "PlanTenur": 0,
            "FreeMonth": 0,
            "LastAdjMonths": 0,
            "IncRentPerc": 0,
            "TotalInstall": watch("TotalInstall"),
            "NetAmt": 0,
            "MonthlyAmt": 0,
            "TransPlanId": 1,
            "TrspChrg": 0,
            "MessPlanId": 1,
            "MessChrg": 0,
            "TAmount": 0,
            "MAmount": 0,
            "Tamt": 0,
            "TotNetAmt": 0,
            "TopupAmt": 0,
            "bookingType": "new"
        })
        // setMobileNo("91");
        setValue("BookDtFrom", moment(todayDate).format("yyyy-MM-DD"));
        setResidentId(-1);
        setSelectedRow({});
        setPromoCodeID(-1);
        setPlanDrp([]);
    }

    useEffect(() => {
        handleCalulate();
    }, [watch("BedRent")]);

    const handleSubmitClick = async () => {
        if (Object.keys(SelectedRow).length === 0) {
            toast.info("Please Select The Room");
            return;
        } else if (ResidentId === -1) {
            toast.info("Enter Valid Mobile Number ");
            return;
        } else if (watch("TopupId") === "") {
            toast.info("Select TopUp");
            return;
        } else if (watch("RoomPlanId") === "") {
            toast.info("Select Plan  ");
            return;
        }

        setIsSubmitting(true);
        try {
            const availabilityResponse = await axiosInstance.post('BedCalendar/GetPropWiseBedCalendarMonthRoomBed', {
                RoomBedId: SelectedRow.RoomBedId,
                PropId: watch('PropId'),
                BookDtFrom: watch('BookDtFrom'),
                CheckoutDt: watch('CheckoutDt'),
                Flag: "",
                OldRoomBedId: ''
            });

            if (availabilityResponse.data.Status === 0) {
                toast.error(availabilityResponse.data.Message);
                setIsSubmitting(false);
                return;
            }
        } catch (error) {
            toast.error("Error checking room availability");
            setIsSubmitting(false);
            return;
        }

        const Obj = watch();
        const bookingType = watch("bookingType") === "new" ? "N" : "R";
        let Payload = {
            "BookDt": watch('BookDt'),
            "PropId": watch('PropId'),
            "ResidentId": ResidentId,
            "MobileNo": watch('MobileNo'),
            "RoomTypeId": SelectedRow.RoomTypeId || 1,
            "RoomViewId": SelectedRow.RoomViewId || 1,
            "RoomId": SelectedRow.RoomId || 1,
            "BedCatId": 1,
            "Duration": parseInt(watch('Duration')),
            "DepositeAmt": watch('DepositAmt') ? parseInt(watch('DepositAmt')) : 0,
            "AdvcRcble": watch('AdvcRcble') || 0,
            "BedRent": watch("BedRent") || SelectedRow.BedRent || 1,
            "EnqId": 1,
            "BookDtFrom": watch('BookDtFrom'),
            "BookUpToDt": watch('BookUpToDt'),
            "RoomBedId": SelectedRow.RoomBedId || 1,
            "RoomBedTypeId": SelectedRow.RoomBedTypeId || 1,
            "CheckinDt": watch('BookDtFrom'),
            "CheckoutDt": watch('CheckoutDt'),
            "RoomPlanId": watch('RoomPlanId') !== "" ? parseInt(watch('RoomPlanId')) : 1,
            "PromoDiscAmt": watch('PromoDiscAmt') || 0,
            "FreeMonth": watch("FreeMonth") || 0,
            "SplDiscAmt": 5.0,
            "BookSt": location.state.BookSt,
            "CancelReason": "No Show",
            "BookRef": watch('BookRef'),
            "BookRefId": 1,
            "BookRemark": watch('BookRemark'),
            "DiscType": watch("DiscType") || '',
            "PerMonthAmt": 0,
            "ChargeMonths": 0,
            "MonthId": 1,
            "MonthlyAmt": watch("MonthlyAmt") || 0,
            "MonthlyDisc": (watch("BedRent") - watch("MonthlyAmt")),
            "MonthlyNetAmt": watch("MonthlyAmt") || 0,
            "CouponId": watch('CouponId') || 1,
            "CouponNo": watch('CouponNo') || '',
            "CrType": location.state.flag,
            "TopupId": watch('TopupId') || 0,
            "Topupdays": watch('Topupdays') || 0,
            "TopupAmt": watch('TopupAmt') || 0,
            "NetAmt": watch('NetAmt') ? parseInt(watch('NetAmt')) : 0,
            "Status": "1",
            "CreatedBy": parseInt(UserId),
            "BillCycle": watch('BillCycle'),
            "FreeMonthValue": 150.00,
            "TotalRent": watch('TotalRent') || 0,
            "DepRctId": 0,
            "DepRctDt": "1900-01-01T10:00:00",
            "DepRctAmt": 0.00,
            "DepBalAmt": 0.00,
            "PaymentSt": "P",
            "MonthName": "December",
            "DiscAmt": watch('DiscAmt'),
            "TrspChrg": watch('TrspChrg'),
            "TotNetAmt": watch("TotNetAmt"),
            "TransPlanId": watch("TransPlanId") || 1,
            "MessPlanId": watch("MessPlanId") || 1,
            "MessChrg": watch("MessChrg"),
            "FirstName": watch("FirstName"),
            "LastName": watch("LastName"),
            "DiscountAmt": watch("AMTDISCOUNT"),
            "BookingType": bookingType,
            "LastBookId": lastBookId,
            "NewBookId": 0
        }

        if (Mode === "view") {
            try {
                const response = await axiosInstance.post(`TrnBooking/InsertTrnBooking`,
                    Payload,
                );

                if (response.data.Status === 0) {
                    toast.success(response.data.Message, { autoClose: 1000 });
                    const dataMessage = response.data.Data;
                    if (dataMessage) {

                        const bookingIdMatch = dataMessage.match(/Booking Id is:(\d+)/);
                        const bookingNoMatch = dataMessage.match(/Booking No is:(\S+)/);

                        if (bookingIdMatch && bookingIdMatch[1]) {
                            const newBookingId = parseInt(bookingIdMatch[1]);

                            setBookId(newBookingId);
                            setLastBookId(newBookingId);

                            navigate(`/renewbooking?bookId=${newBookingId}`, {
                                state: {
                                    BookId: newBookingId,
                                    fromAccGen: false,
                                    flag: location.state.flag,
                                    isSubmitted: true
                                }
                            });

                            await fetchTransactionData(newBookingId, "R");
                        }

                        if (bookingNoMatch && bookingNoMatch[1]) {
                            const newBookingNo = bookingNoMatch[1];
                            setValue('BookNo', newBookingNo);
                        }
                    }

                    setMode("view");
                    setAllDisUnable(false);
                    setIsSubmitted(true);

                } else {
                    toast.info(response.data.Message);
                }
            } catch (error) {
                setIsSubmitting(false);
            }
        } else {
            Payload = { ...Payload, BookId, BookNo: watch("BookNo"), UpdatedBy: parseInt(UserId) };
            delete Payload.CreatedBy;

            try {
                const response = await axiosInstance.post(`TrnBooking/UpdateTrnBooking`,
                    Payload,
                );

                if (response.data.Status === 0) {
                    toast.success(response.data.Message, { autoClose: 1000 });

                    const dataMessage = response.data.Data;
                    if (dataMessage) {
                        const bookingIdMatch = dataMessage.match(/Booking Id is:(\d+)/);
                        const bookingNoMatch = dataMessage.match(/Booking No is:(\S+)/);

                        if (bookingIdMatch && bookingIdMatch[1]) {
                            const newBookingId = parseInt(bookingIdMatch[1]);
                            navigate(`/renewbooking?bookId=${newBookingId}`, {
                                state: {
                                    BookId: newBookingId,
                                    fromAccGen: false,
                                    flag: location.state.flag,
                                    isSubmitted: true
                                }
                            });
                            setBookId(newBookingId);
                            setLastBookId(newBookingId);

                            await fetchTransactionData(newBookingId, "R");
                        }

                        if (bookingNoMatch && bookingNoMatch[1]) {
                            const newBookingNo = bookingNoMatch[1];
                            setValue('BookNo', newBookingNo);
                        }
                    }

                    await UnLock(BookId, "TrnBooking", "BookId");
                    setAllDisUnable(false);
                    setIsSubmitted(true);
                } else {
                    toast.info(response.data.Message);
                }
            } catch (error) {
                console.error('Error getting To Insert:', error);
            }
        }

        setIsSubmitting(false);
    }

    const handleRowDoubleClick = async (row) => {
        const {
            WingName,
            FloorName,
            RoomTypeName,
            RoomViewNAme,
            RoomBedTypeName,
            RoombedName,
            BedRent,
            RoomBedId
        } = row;

        const obj = {
            WingName,
            FloorName,
            RoomTypeName,
            RoomViewNAme,
            RoomBedTypeName,
            RoombedName,
            BedRent
        };
        setSelectedRow(row);
        setSelectedBedData(obj)
        localStorage.setItem("selectedBedData", JSON.stringify(obj));
        window.postMessage({ action: "fetchBedData" }, "*");
        setOpenHistoryTable(false);
        if (BookId !== -1) {
            try {
                setOpenLoader(true);
                const response = await axiosInstance.post('BedCalendar/GetPropWiseBedCalendarMonthRoomBed', {
                    RoomBedId: RoomBedId,
                    PropId: watch('PropId'),
                    BookDtFrom: DateFrom.format('YYYY-MM-DD'),
                    CheckoutDt: DateTo.format('YYYY-MM-DD'),
                    Flag: "",
                    OldRoomBedId: ''
                });

                if (response.data.Status === 0) {
                    toast.error(response.data.Message);
                    // await handleMobileChange(watch('MobileNo'), "B");
                }
            } catch (error) {
                console.error('Error changing room:', error);
                // toast.error("Error changing room");
            } finally {
                setOpenLoader(false);
            }
        }
    };

    // const handleCalulate = () => {
    //     let TotAmt = (((watch("BedRent") * watch('Duration') / 100)) * watch("IncRentPerc"));
    //     setValue("TotalRent", ((watch("BedRent") * watch('Duration')) + TotAmt));
    //     let MonthlyAMt = Math.round(((watch("TotalRent") - watch("DiscAmt")) / watch("Duration")));
    //     setValue("MonthlyAmt", MonthlyAMt);
    //     setValue("NetAmt", watch("TotalRent") - watch("DiscAmt"));
    //     let NetPayable = (parseInt(watch("NetAmt")) - (parseFloat(watch("FreeMonth")) * MonthlyAMt));
    //     setValue("AdvcRcble", Math.round(NetPayable));
    //     setTmt();

    // }
    const handleCalulate = () => {
        let TotAmt = (((watch("BedRent") * watch('Duration') / 100)) * watch("IncRentPerc"));
        setValue("TotalRent", ((watch("BedRent") * watch('Duration')) + TotAmt));
        let MonthlyAMt = Math.round((watch("TotalRent") / watch("Duration")));
        setValue("MonthlyAmt", MonthlyAMt);
        setValue("NetAmt", watch("TotalRent"));
        let totalPayable = (parseInt(watch("NetAmt")) - (parseFloat(watch("FreeMonth")) * MonthlyAMt));
        let NetPayable = totalPayable - watch("DiscAmt")
        setValue("AdvcRcble", Math.round(NetPayable));
        setTmt();
    };

    const setTmt = () => {
        setValue("TotNetAmt", ((parseInt(watch("AdvcRcble")) || 0) + (parseInt(watch("TrspChrg")) || 0) + (parseInt(watch("MessChrg")) || 0)));
        let amtInWord = numToChar(watch("TotNetAmt"));
        setValue("AmtInWor", amtInWord.concat(" Only/-"));
    }

    const fetchTopUpData = async (RTypeId, ByFlag) => {
        try {
            const response = await axiosInstance.post(`MstTopup/getMstTopupdrp`, {
                "RoomTypeId": RTypeId,
                "Flag": "",
                "PropId": watch("PropId"),
            });
            if (response.data.Status === 0) {
                setTopUpDrp(response.data.Data);
                if (ByFlag === "button") {
                    setValue("TopupId", response.data.Data[0].TopupID);
                    setValue("TopupAmt", response.data.Data[0].TopupAmt);
                }
            } else {
                // toast.info('Error fetching TopUpData data');
                setTopUpDrp([]);
            }
        } catch (error) {
            // toast.error('Error fetching TopUpData data');
        }
    };

    const handlePlanChange = (value) => {
        setValue("RoomPlanId", value);
        let obj = PlanDrp.find(plan => plan.RoomPlanID === value);
        if (obj) {
            const { PlanTenur, FreeMonth, LastAdjMonths, IncRentPerc, TotalInstall, DepositAmt, PlanName } = obj;
            let setObj = { PlanTenur, FreeMonth, LastAdjMonths, IncRentPerc, TotalInstall, DepositAmt, PlanName };

            for (let key in setObj) {
                setValue(key, setObj[key]);
            }

            handleCalulate();
        }
    }

    const handleClickCheckAvaCal = () => {
        const startDate = dayjs(watch('BookDtFrom'));
        const endDate = dayjs(watch('BookUpToDt'));
        setDateFrom(startDate);
        setDateTo(endDate);
        setOpenHistoryTable(true);
    }

    const handleCloseRoom = () => {
        setOpenHistoryTable(false)
    }

    const handlePrevClick = () => {
        fetchTransactionData(BookId, "P");
    }

    const handleNextClick = () => {
        fetchTransactionData(BookId, "N");
    }

    const handleAddClick = () => {
        setMode("add");
        setAllDisUnable(true);
        setHistoryData([]);
        resetFunc();
        setIsSubmitted(false);
        if (PropertyDrp.length > 0) {
            // setValue("PropId", PropertyDrp[0]?.Id);
            fetchPlanDrpData();
        }
    }

    const handleEditClick = async () => {
        if (TransactionData[0].BookSt === "B") {
            let Flag = await checkAndLock(BookId, "TrnBooking", "BookId");
            switch (Flag) {
                case 0:
                    setMode("view");
                    setAllDisUnable(true);
                    break;
                case 1:
                    toast.info("Record  Already Locked", { autoClose: 500 });
                    break;
                case 2:
                    toast.info("Record Failed To Locked", { autoClose: 500 });
                    break;
                default:
                    toast.info("Something Went Wrong", { autoClose: 500 });
            }
        } else {
            toast.info("Can Not be Edit this record.. (Booking Confirmed)");
        }
    }

    const handleDeleteClick = () => {
        if (TransactionData[0]?.BookSt === "B") {
            setOpenDForDelete(true);
        } else {
            toast.info("Cannot Delete Confirm Record!");
        }
    }

    const handleClickBackToTable = () => {
        navigate('/bookingtable')
    }

    const handleCancelClick = async () => {
        setAllDisUnable(prev => !prev);
        setIsSubmitted(false);
        if (BookId === -1 && Mode === "add") {
            await fetchTransactionData(1, "L")
        } else {
            await UnLock(BookId, "TrnBooking", "BookId");
            await fetchTransactionData(BookId, "L")
        }
    }

    const handleCancelDialogButton = () => {
        setopenConfirmDialog(false);
    }

    const handleConfirmDelete = async () => {
        navigate(`/resident`, { state: { IsFromTransaction: true, Mobile: watch('MobileNo') } })
    }

    const handleBookingHistoryClick = () => {
        setOpenHistoryTableDialog1(true);
    }

    const handleClickCancelBooking = () => {
        if (BookId != -1 && Mode == "view" && TransactionData[0].BookSt != 'C') {
            setOpenDForCancel(true);
        } else if (TransactionData[0].BookSt == 'C') {
            toast.info("Cannot Cancel The Confirm Record!!");

        } else {
            toast.info("Not An Valid Transaction To Cancel");
        }
    }

    const handleCancelBooking = async () => {
        let Flag = "";
        if (TransactionData[0].BookSt === "B") {
            Flag = "X";
        } else if (TransactionData[0].BookSt === "X") {
            Flag = "B";
        }
        try {
            const response = await axiosInstance.post(`TrnBooking/TrnBookingConfirmation`, {
                "BookId": TransactionData[0].BookId,
                "CreatedBy": UserId,
                "Flag": Flag
            });

            if (response.data.Status === 0) {
                toast.success(response.data.Message);
                await fetchTransactionData(BookId, "R");
            } else {
                toast.error(response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching company data:', error);
        }
    }
    const handleClickOpen = () => {
        setOpenHistoryTableDialog(true);
    };

    const handleClose = () => {
        setOpenHistoryTableDialog(false);
        setPage(0);
        setTimeout(() => {
            setSearchTerms({});
        }, [500]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleCancelDButton = () => {
        setOpenDForDelete(false);
    }

    const handleCancelCButton = () => {
        setOpenDForCancel(false);
    }

    const handleConfirmDDelete = () => {
        if (BookId != -1 && Mode == "view") {
            fetchTransactionData(BookId, "D");
        }
        setOpenDForDelete(false);
    }

    const handleConfirmCancel = () => {
        if (BookId != -1 && Mode == "view" && TransactionData[0].BookSt != 'C') {
            handleCancelBooking()
        }
        setOpenDForCancel(false);
    }

    const handleTopUpChange = (e) => {
        setValue(e.target.name, e.target.value);
        let Amt = 0;
        if (e.target.name === "TopupId") {
            let getObj = TopUpDrp.find(obj => obj.TopupID === e.target.value);
            if (getObj) {
                setValue("TopupAmt", getObj.TopupAmt);
                setValue("Topupdays", getObj.Topupdays);
                Amt = getObj.TopupAmt;
            }
        } else if (e.target.name === "TransPlanId") {
            let getObj = TransPlanDrp.find(obj => obj.TransPlanID === e.target.value);
            if (getObj) {
                setValue("TrspChrg", getObj.Amount);
                setValue("TransPlanId", getObj.TransPlanID);
                Amt = getObj.Amount;
            }
        } else if (e.target.name === "MessPlanId") {
            let getObj = MessPlanDrp.find(obj => obj.MessPlanID === e.target.value);
            if (getObj) {
                setValue("MessChrg", getObj.Amount);
                setValue("MessPlanId", getObj.MessPlanID);
                Amt = getObj.Amount;
            }
        }
        setTmt();
        // setValue("Tamt",(Amt+watch("Tamt")));
    }

    const handleEmailSentLink = async () => {
        setOpenLoader(true);
        const propId = parseInt(watch("PropId"));
        const userId = parseInt(UserId);
        const baseUrl = window.location.origin;
        const property = PropertyDrp.find(p => p.Id === propId);
        const propName = property?.Name || watch("PropName") || "Clanbridge Property";
        const currentPytAdvId = watch("PytAdvId") || pytAdvId;
        const currentPytAdvNo = watch("PytAdvNo") || pytAdvNo;

        const gatewayType = property?.GateWay_Type || gatewayType || 'CashFree';
        let paymentResponse = null;

        try {

            if (gatewayType === 'CashFree') {
                const paymentDetails = {
                    customer_details: {
                        customer_email: watch("Email"),
                        customer_name: watch("FirstName"),
                        customer_phone: watch("MobileNo") || ""
                    },
                    link_amount: watch("DepositAmt"),
                    link_auto_reminders: true,
                    link_currency: "INR",
                    link_expiry_time: "2026-06-09T15:04:05+05:30",
                    link_id: `Testing9062026`,
                    link_meta: {
                        notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        upi_intent: false
                    },
                    link_minimum_partial_amount: watch("DepositAmt") || 0,
                    link_notes: {
                        key_1: "CashFreepay",
                        key_2: "linkCashfree"
                    },
                    link_notify: {
                        send_email: true,
                        send_sms: true
                    },
                    link_partial_payments: true,
                    link_purpose: `Booking Advance, # ${watch("PytAdvNo")}`,
                    ResidentId: ResidentId,
                    Flag: "Active",
                    Remark: "Testing",
                    TrjType: "TrnPytAdv",
                    TrjDocNo: currentPytAdvNo,
                    TrjDocId: currentPytAdvId,
                    cf_payment_id: "",
                    payment_status: "",
                    PropId: propId
                };

                const response = await axiosInstanceForPG.post(
                    `PaymentGatewayLog/CreateCashFreeLink`,
                    paymentDetails,
                );

                if (response.data.Status == 0) {
                    handleLoaderClose();
                    return toast.success(response.data.Message);
                }
                if (response.data.Status === 1) {
                    handleLoaderClose();
                    return toast.error(response.data.Message);
                }

                paymentResponse = response.data;
                if (typeof paymentResponse === 'string') {
                    paymentResponse = JSON.parse(paymentResponse);
                }

                if (!paymentResponse || !paymentResponse.link_url) {
                    toast.error("Failed to create payment link");
                    handleLoaderClose();
                    return;
                }

            } else if (gatewayType === 'Instamojo') {
                const paymentDetails = {
                    purpose: `Booking Advance, # ${watch("PytAdvNo")}`,
                    amount: watch("DepositAmt") || 0,
                    buyer_name: watch("FirstName") || '',
                    email: watch("Email") || '',
                    phone: watch("MobileNo") || '',
                    redirect_url: `${baseUrl}/payment-success`,
                    redirecturl: `${baseUrl}/payment-success/`,
                    webhook_url: '',
                    ResidentId: ResidentId,
                    TrjDocId: currentPytAdvId || 0,
                    TrjType: "TrnPytAdv",
                    TrjDocNo: currentPytAdvNo || '',
                    PropId: propId || 0,
                };

                const response = await axiosInstanceForPG.post(
                    `Payment/CreatePaymentOrder`,
                    paymentDetails,
                );

                if (response.data.Status == 0) {
                    handleLoaderClose();
                    return toast.success(response.data.Message);
                }
                if (response.data.Status === 1) {
                    handleLoaderClose();
                    return toast.error(response.data.Message);
                }

                paymentResponse = JSON.parse(response.data);

                if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
                    console.error("Invalid payment response:", paymentResponse);
                    toast.error("Failed to create payment link");
                    handleLoaderClose();
                    return;
                }

            } else {
                toast.error(`Unsupported gateway type: ${gatewayType}`);
                handleLoaderClose();
                return;
            }


            const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
            const paymentUrl = gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
            const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;


            if (gatewayType === 'CashFree' && paymentResponse.Status === 0 && paymentResponse.Message === "Payment Link Already Sent!") {
                const existingPaymentLink = paymentResponse.Data;
                const Subject = `Contract Renewal Request at Clanbridge Living 🛏️✨ `;
                const Body = `Hey there ${watch("FirstName")} ${watch("LastName")} !!,<br><br>
                Here are the details of your renewal:<br><br>
                📍 Property: <strong>${propName}</strong><br>
                🛏️ Bed Type: <strong>${watch("RoomBedTypeName")}</strong><br>
                💼 Duration: <strong>${watch("PlanTenur")} Month</strong><br><br>
                To confirm your renewal, simply click the "Book Now" below and pay your new contract booking advance: <br><br>   
                👉 Click Here : <a href="${existingPaymentLink}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 3px 8px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Book Now</a><br><br>
                
                <strong>By clicking "Book Now" you agree to the following general terms and conditions of this booking:</strong><br><br>
                
                <div style="margin-left: 15px; line-height: 1.6;">
                    <strong>1.</strong> Your renewal will be confirmed only once booking advance payment is received.<br>
                    <strong>2.</strong> You will be allocated the same bed you are currently staying in.<br>
                    <strong>3.</strong> Booking advance is refundable within 7 days from payment of booking advance. If booking is cancelled after 7 days of payment of booking advance, the same shall stand cancelled and no refund of booking advance shall be issued.<br>
                    <strong>4.</strong> The booking advance shall be converted into security deposit at the time of check in and no additional amount shall be charged towards security deposit.<br>
                    <strong>5.</strong> In case of discontinuation of stay before the agreed duration, only security deposit amount shall be refunded within 30-60 days from check out post damage deductions, if any. All other advances paid shall not be refundable.<br>
                    <strong>6.</strong>  Post the term of stay and successful check out, you are requested to email your bank details to <strong>sales@clanbridge.com</strong> so that security deposit can be refunded to you. The amount balance post charges towards damages or penalties shall be refunded to the account details shared within 30-60 days.<br>
                    <strong>7.</strong> Transportation service, if provided, shall be available on fixed routes on a fixed schedule. Changes in schedule cannot be made on a case-to-case basis.<br>
                    <strong>8.</strong> Food consumption is allowed in the dining hall only. Guest meals shall be chargeable. In case tiffin service is provided, the resident shall be responsible to bring back tiffins to campus safely and handed over to the concerned person, failing which prescribed amount shall be charged separately.<br>
                    <strong>9.</strong> Fee payment after due date shall attract delay penalties.<br>
                    <strong>10.</strong> In case of medical assistance required by any resident, all medical bills and expenses shall be paid by the resident only. Clanbridge shall provide paid cabs in case of medical emergencies only.<br>
                    <strong>11.</strong> Any amount refundable post successful check out shall be refunded within 30 - 60 days from the date of receipt of bank details on mail in which refund needs to be credited.<br>
                    <strong>12.</strong> Room changes are chargeable at Rs 1,000 per change request.<br>
                    <strong>13.</strong> Hot water is available during winter season only.<br>
                    <strong>14.</strong> Maximum 45 days leave between both contracts shall be allowed. Your billing shall start either from the actual date of re-check in or the billing cycle date within 45 days from the end of your previous contract, whichever is earlier. For eg if your current contract ends on 31st May, your next billing will start maximum on 15th July or your actual check in date, in case it's earlier than 15th July, as per the billing cycles of Clanbridge Living.<br>
                    <strong>15.</strong> There will be maintenance activities carried your in your room while you are on leave, hence it is advisable to keep all your belongings safely locked in your cupboard.<br>
                </div>
                
                <br>If you have any questions or need assistance, feel free to email us at <strong>sales@clanbridge.com</strong> or call us at <strong>9953398502.</strong><br><br>

                Welcome to the Clan!<br><br>

                Warm regards,<br>
                <strong>Team Clanbridge</strong><br>
                www.clanbridge.com<br>
                <img src="https://media.licdn.com/dms/image/v2/D4D3DAQG1SYkFnicApg/image-scale_191_1128/image-scale_191_1128/0/1664167472606/clanbridge_living_cover?e=2147483647&v=beta&t=yJeTya-6731XGwt3ypXs9JWKUAU7U4b69cXyYKcIZ-Q" alt="Clanbridge Logo" style="max-width: 200px; height: auto; margin-top: 10px;">

                <div style="font-size: 12px; color: #555; border-top: 1px solid #eee; padding-top: 10px; margin-top: 20px;">
                    <strong>NOTICE:</strong> The information contained in this e-mail message and/or attachments to it may contain confidential or privileged information. If you are not the intended recipient, any dissemination, use, review, distribution, printing or copying of the information contained in this e-mail message and/or attachments to it are strictly prohibited. If you have received this communication in error, please notify us by reply e-mail or telephone and immediately and permanently delete the message and any attachments. Thank you.
                </div>`;

                const emailRequest = {
                    ToEmail: watch("Email") ? [watch("Email")] : [],
                    Subject,
                    Body,
                    Attachments: '',
                    attachmentFilePaths: [],
                    PropId: propId,
                    UserId: userId,
                    TblName: "TrnPytAdv",
                    Id: currentPytAdvId
                };

                const emailResponse = await axiosInstanceForPG.post(
                    `EmailRequest/SendEmail`,
                    emailRequest,
                );

                if (emailResponse.data.Status === 0) {
                    toast.success("Payment Link Already Sent.!");
                } else {
                    toast.info(emailResponse.data.Message);
                }
                handleLoaderClose();
                return;
            }

            // Insert payment log based on gateway type
            let paymentLogPayload;
            if (gatewayType === 'CashFree') {
                paymentLogPayload = {
                    id: paymentResponse.link_id,
                    cf_link_id: paymentResponse.cf_link_id,
                    phone: paymentResponse.customer_details.customer_phone,
                    email: paymentResponse.customer_details.customer_email,
                    buyer_name: paymentResponse.customer_details.customer_name || 'null',
                    amount: paymentResponse.link_amount,
                    purpose: paymentResponse.link_purpose,
                    expires_at: null,
                    status: paymentResponse.link_status,
                    send_sms: paymentResponse.link_notify.send_sms,
                    send_email: paymentResponse.link_notify.send_email,
                    sms_status: 'null',
                    email_status: 'null',
                    shorturl: 'null',
                    longurl: paymentResponse.link_url,
                    redirect_url: paymentResponse.link_meta.return_url,
                    webhook: 'null',
                    allow_repeated_payments: true,
                    created_at: paymentResponse.link_created_at,
                    modified_at: paymentResponse.link_created_at,
                    link_qrcode: paymentResponse.link_qrcode,
                    ResidentId: ResidentId,
                    TrjDocNo: currentPytAdvNo,
                    TrjDocId: currentPytAdvId,
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Testing",
                    Gatewaytype: "CashFree",
                };
            } else {
                paymentLogPayload = {
                    id: paymentResponse.payment_request.id,
                    phone: paymentResponse.payment_request.phone,
                    email: paymentResponse.payment_request.email,
                    buyer_name: paymentResponse.payment_request.buyer_name,
                    amount: paymentResponse.payment_request.amount,
                    purpose: paymentResponse.payment_request.purpose,
                    expires_at: paymentResponse.payment_request.expires_at,
                    status: paymentResponse.payment_request.status,
                    send_sms: paymentResponse.payment_request.send_sms,
                    send_email: paymentResponse.payment_request.send_email,
                    sms_status: paymentResponse.payment_request.sms_status,
                    email_status: paymentResponse.payment_request.email_status,
                    shorturl: paymentResponse.payment_request.shorturl,
                    longurl: paymentResponse.payment_request.longurl,
                    redirect_url: paymentResponse.payment_request.redirect_url,
                    webhook: paymentResponse.payment_request.webhook,
                    allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
                    created_at: paymentResponse.payment_request.created_at,
                    modified_at: paymentResponse.payment_request.modified_at,
                    ResidentId: ResidentId,
                    TrjDocNo: currentPytAdvNo,
                    TrjDocId: currentPytAdvId,
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Testing",
                    Gatewaytype: "Instamojo",
                };
            }

            await axiosInstance.post(
                'PaymentGatewayLog/InsertPaymentRequestLog',
                paymentLogPayload
            );


            const Subject = `Contract Renewal Request at Clanbridge Living 🛏️✨ `;
            const Body = `Hey there ${watch("FirstName")} ${watch("LastName")} !!,<br><br>
            Here are the details of your renewal:<br><br>
            📍 Property: <strong>${propName}</strong><br>
            🛏️ Bed Type: <strong>${watch("RoomBedTypeName")}</strong><br>
            💼 Duration: <strong>${watch("PlanTenur")} Month</strong><br><br>
            To confirm your renewal, simply click the "Book Now" below and pay your new contract booking advance: <br><br>   
            👉 Click Here : <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 3px 8px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Book Now</a><br><br>
            
            <strong>By clicking "Book Now" you agree to the following general terms and conditions of this booking:</strong><br><br>
            
            <div style="margin-left: 15px; line-height: 1.6;">
                <strong>1.</strong> Your renewal will be confirmed only once booking advance payment is received.<br>
                <strong>2.</strong> You will be allocated the same bed you are currently staying in.<br>
                <strong>3.</strong> Booking advance is refundable within 7 days from payment of booking advance. If booking is cancelled after 7 days of payment of booking advance, the same shall stand cancelled and no refund of booking advance shall be issued.<br>
                <strong>4.</strong> The booking advance shall be converted into security deposit at the time of check in and no additional amount shall be charged towards security deposit.<br>
                <strong>5.</strong> In case of discontinuation of stay before the agreed duration, only security deposit amount shall be refunded within 30-60 days from check out post damage deductions, if any. All other advances paid shall not be refundable.<br>
                <strong>6.</strong>  Post the term of stay and successful check out, you are requested to email your bank details to <strong>sales@clanbridge.com</strong> so that security deposit can be refunded to you. The amount balance post charges towards damages or penalties shall be refunded to the account details shared within 30-60 days.<br>
                <strong>7.</strong> Transportation service, if provided, shall be available on fixed routes on a fixed schedule. Changes in schedule cannot be made on a case-to-case basis.<br>
                <strong>8.</strong> Food consumption is allowed in the dining hall only. Guest meals shall be chargeable. In case tiffin service is provided, the resident shall be responsible to bring back tiffins to campus safely and handed over to the concerned person, failing which prescribed amount shall be charged separately.<br>
                <strong>9.</strong> Fee payment after due date shall attract delay penalties.<br>
                <strong>10.</strong> In case of medical assistance required by any resident, all medical bills and expenses shall be paid by the resident only. Clanbridge shall provide paid cabs in case of medical emergencies only.<br>
                <strong>11.</strong> Any amount refundable post successful check out shall be refunded within 30 - 60 days from the date of receipt of bank details on mail in which refund needs to be credited.<br>
                <strong>12.</strong> Room changes are chargeable at Rs 1,000 per change request.<br>
                <strong>13.</strong> Hot water is available during winter season only.<br>
                <strong>14.</strong> Maximum 45 days leave between both contracts shall be allowed. Your billing shall start either from the actual date of re-check in or the billing cycle date within 45 days from the end of your previous contract, whichever is earlier. For eg if your current contract ends on 31st May, your next billing will start maximum on 15th July or your actual check in date, in case it's earlier than 15th July, as per the billing cycles of Clanbridge Living.<br>
                <strong>15.</strong> There will be maintenance activities carried your in your room while you are on leave, hence it is advisable to keep all your belongings safely locked in your cupboard.<br>
            </div>
            
            <br>If you have any questions or need assistance, feel free to email us at <strong>sales@clanbridge.com</strong> or call us at <strong>9953398502.</strong><br><br>

            Welcome to the Clan!<br><br>

            Warm regards,<br>
            <strong>Team Clanbridge</strong><br>
            www.clanbridge.com<br>
            <img src="https://media.licdn.com/dms/image/v2/D4D3DAQG1SYkFnicApg/image-scale_191_1128/image-scale_191_1128/0/1664167472606/clanbridge_living_cover?e=2147483647&v=beta&t=yJeTya-6731XGwt3ypXs9JWKUAU7U4b69cXyYKcIZ-Q" alt="Clanbridge Logo" style="max-width: 200px; height: auto; margin-top: 10px;">

            <div style="font-size: 12px; color: #555; border-top: 1px solid #eee; padding-top: 10px; margin-top: 20px;">
                <strong>NOTICE:</strong> The information contained in this e-mail message and/or attachments to it may contain confidential or privileged information. If you are not the intended recipient, any dissemination, use, review, distribution, printing or copying of the information contained in this e-mail message and/or attachments to it are strictly prohibited. If you have received this communication in error, please notify us by reply e-mail or telephone and immediately and permanently delete the message and any attachments. Thank you.
            </div>`;

            const emailRequest = {
                ToEmail: watch("Email") ? [watch("Email")] : [],
                Subject,
                Body,
                Attachments: '',
                attachmentFilePaths: [],
                PropId: propId,
                UserId: userId,
                TblName: "TrnPytAdv",
                Id: currentPytAdvId
            };

            const emailResponse = await axiosInstanceForPG.post(
                `EmailRequest/SendEmail`,
                emailRequest,
            );

            if (emailResponse.data.Status === 0) {
                toast.success("Payment Link Sent Successfully");
            } else {
                toast.info(emailResponse.data.Message);
            }

        } catch (error) {
            console.error('Error in payment process:', error);
            if (error.response) {
                console.error('Error Response:', error.response);
                toast.error(`Error: ${error.response.data.Message || 'Unknown error'}`);
            } else if (error.request) {
                console.error('Error Request:', error.request);
                toast.error('No response from the server');
            } else {
                console.error('General Error:', error.message);
                toast.error("Error processing payment request");
            }
        } finally {
            handleLoaderClose();
        }
    };


    const numToChar = (num) => {
        if (num === 0) return 'Zero';

        const belowTwenty = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const aboveHundred = ['Hundred', 'Thousand', 'Lakh', 'Crore'];

        const startConvert = (n) => {
            let res = '';

            if (n >= 10000000) {
                res += startConvert(Math.floor(n / 10000000)) + ' Crore ';
                n %= 10000000;
            }
            if (n >= 100000) {
                res += startConvert(Math.floor(n / 100000)) + ' Lakh ';
                n %= 100000;
            }
            if (n >= 1000) {
                res += startConvert(Math.floor(n / 1000)) + ' Thousand ';
                n %= 1000;
            }
            if (n >= 100) {
                res += startConvert(Math.floor(n / 100)) + ' Hundred ';
                n %= 100;
            }
            if (n >= 20) {
                res += tens[Math.floor(n / 10) - 2] + ' ';
                n %= 10;
            }
            if (n > 0) {
                res += belowTwenty[n] + ' ';
            }

            return res.trim();
        };

        const integerPart = Math.floor(num);
        const decimalPart = Math.round((num - integerPart) * 100);

        let result = startConvert(integerPart);
        if (decimalPart > 0) {
            result += ' and ' + startConvert(decimalPart) + ' Paise';
        }

        return result.trim();
    };

    const handleLoaderClose = () => {
        setOpenLoader(false);
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    const handleBillingDetails = async () => {

        if (BookId === -1) {
            toast.info("No transaction is visible");
            return;
        }

        try {
            setOpenLoader(true); // Show loader while fetching
            const response = await axiosInstance.post(
                'TrnBooking/GetReportTrnBooking',
                {
                    "BookId": BookId,
                    "Flag": "R"
                }
            );

            console.log("API Response:", response.data); // Add this for debugging

            if (response.data.Status === 0 && response.data.Data) {
                setBillingDetails(response.data.Data);
                setOpenBillingModal(true);

                await fetchPlanDataState(TransactionData[0].RoomPlanId);
                await fetchPayAdvice(BookId);
                await fetchPayGenerate(BookId);
                await fetchPendingDetails(BookId);
            } else {
                toast.error('No billing details found');
            }
        } catch (error) {
            console.error('Error fetching billing details:', error);
            toast.error('Error fetching billing details');
        } finally {
            setOpenLoader(false); // Hide loader
        }
    };

    const fetchPlanDataState = async (PlanId) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
                "RoomPlanID": PlanId,
                "Flag": "R"
            });

            if (response.data.Status === 0) {
                console.log("PlanState Data", response);
                setPlanDataState(response.data.Data);
                setOpenBillingModal(true);
            } else {
                console.error('Error fetching Grid data:', response.data.Message);

            }
        } catch (error) {
            console.error('Error fetching plan data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPayAdvice = async (BookId) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "PytAdvDt": "2025-03-07",
                "Flag": "BookingWise",
                "BookId": BookId
            });

            if (response.data.Status === 0) {
                setPayAdvice(response.data.Data);
                setOpenBillingModal(true);
            } else {
                console.error('Error fetching Grid data:', response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching plan data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPayGenerate = async (Id) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "PytAdvDt": "2025-02-26",
                "Flag": "GenPytAdv",
                "BookId": Id
            });

            if (response.data.Status === 0) {
                setPayGenerate(response.data.Data);
                setOpenBillingModal(true);
            } else {
                console.error('Error fetching Grid data:', response.data.Message);

            }
        } catch (error) {
            console.error('Error fetching pay generate data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPendingDetails = async (pendingId) => {

        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "Flag": "PendPytBookWise",
                "BookId": pendingId,
                "PytAdvDt": "2025-05-20"
            });

            if (response.data.Status === 0) {
                setPendingDetails(response.data.Data);
                setOpenBillingModal(true);
            } else {
                console.error('Error fetching Grid data:', response.data.Message);

            }
        } catch (error) {
            console.error('Error fetching pending details data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const handleAccountGenerateClick = async () => {
        if (BookId === -1) {
            toast.info("Transaction is Not Visible!!");

            return;
        }

        setOpenLoader(true);

        try {
            const response = await axiosInstance.post(
                `TrnBooking/AccountGenerateTrnBooking`,
                {
                    "BookId": BookId,
                    "CreatedBy": UserId,
                    "AccountGenerate": "1",
                    "IsAccGen": "",
                    "IsDepPaid": isDepositPaid ? "Y" : "N"
                }
            );

            if (response.data.Status === 0) {
                try {
                    const dataResponse = await axiosInstance.post(`BedCalendar/GetTrnBookingDtlwise`, {
                        "Flag": "",
                        "BookId": BookId
                    });

                    if (dataResponse.data.Status === 0) {
                        const formattedData = dataResponse.data.Data.map(obj => {
                            return { ...obj, PyadDt: moment(obj.PyadDt).format("MM-DD-YYYY") }
                        });
                        sessionStorage.setItem('accountGenerateData', JSON.stringify(formattedData));
                        navigate(`/accgeneratetable`, {
                            state: {
                                accountData: formattedData,
                                bookingInfo: {
                                    residentName: watch("ResidentName"),
                                    bookNo: watch("BookNo"),
                                    mobileNo: watch("MobileNo")
                                }
                            }
                        });
                    } else {
                        toast.error(dataResponse.data.Message || 'Error fetching account data');
                    }
                } catch (error) {
                    console.error('Error fetching account data:', error);
                    toast.error('Error fetching account data');
                }
            } else {
                toast.error(response.data.Message || 'Error in account generation');
            }
        } catch (error) {
            console.error('Error in account generation:', error);
            toast.error('Error in account generation');
        } finally {
            setOpenLoader(false);
        }
    };
    const PropId = watch('PropId');

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box className="form-container">
                <Backdrop
                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                    open={OpenLoader}
                    onClick={handleLoaderClose}
                >
                    <CircularProgress color="inherit" />
                    Please Wait .....
                </Backdrop>
                <ToastContainer />
                <BookingHistory OpenHistoryTableDialog1={OpenHistoryTableDialog1} setOpenHistoryTableDialog1={setOpenHistoryTableDialog1} rows={HistoryData} />
                <BillingDetailsModal open={openBillingModal} onClose={() => setOpenBillingModal(false)}
                    billingData={billingDetails} planData={PlanDataState} payAdvice={PayAdvice}
                    payGenerate={PayGenerate} pendingDetails={PendingDetails}
                />
                <Dialog
                    open={openConfirmDialog}
                    onClose={handleCancelDialogButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" >
                        {" Mobile Number Doesn't Exist "}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Do You Want To Create New Master ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleConfirmDelete}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleCancelDialogButton}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={OpenDForDelete}
                    onClose={handleCancelDButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" >
                        Do You Want To Delete The Transaction ?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleConfirmDDelete}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleCancelDButton}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={OpenDForCancel}
                    onClose={handleCancelCButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" >
                        {TransactionData[0]?.BookSt === "B" ? "Do You Want To Cancel The Transaction" : "Do You Want To Restore The Transaction"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleConfirmCancel}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleCancelCButton}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid container spacing={1} className="rasidant_grid" >
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                onClick={handlePrevClick}
                                disabled={AllDisUnable}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                className='three-d-button-next'
                                onClick={handleNextClick}
                                disabled={AllDisUnable}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            {location.state.flag === "R" ? "Renewal" : "Extend"} Booking
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Booking"
                                mode={Mode}
                                onAdd={handleAddClick}
                                onEdit={handleEditClick}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleClickBackToTable}
                                readOnlyMode={!AllDisUnable}
                                onPrevious={handlePrevClick}
                                onNext={handleNextClick}
                                hideEdit={true}
                                hideAdd={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className="form_field" sx={{ borderRadius: 2, padding: 3 }} >
                        <Grid container spacing={0.5} >
                            <Grid item xs={12} md={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {/* BookStatus on the left */}
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flex: 1,
                                        minWidth: '200px',
                                        gap: 2
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                Book Status:
                                            </Typography>
                                            <Typography variant="body1"
                                                sx={{
                                                    marginLeft: '10px',
                                                    fontWeight: 'bold',
                                                    color: 'purple'
                                                }}>
                                                {watch("BookStatus")}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                Booking Type:
                                            </Typography>
                                            <Typography variant="body1"
                                                sx={{
                                                    marginLeft: '10px',
                                                    fontWeight: 'bold',
                                                    color:
                                                        !TransactionData[0]?.BookingType ? 'green' :
                                                            TransactionData[0]?.BookingType === 'N' ? 'green' :
                                                                TransactionData[0]?.BookingType === 'R' ? 'orange' :
                                                                    'blue'
                                                }}>
                                                {location.state.flag === "R" ? "Renewal" : "Extend"}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Links on the right */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', textDecoration: 'none', }}>
                                        {Mode === "view" && (
                                            <Link
                                                // to="/advicegeneratetable"
                                                to={`/advicegeneratetable?bookNo=${watch('BookNo')}`}
                                                style={{
                                                    cursor: isSubmitted ? 'pointer' : 'default',
                                                    textDecoration: 'none',
                                                    pointerEvents: isSubmitted ? 'auto' : 'none',
                                                    opacity: isSubmitted ? 1 : 0.5
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        display: 'flex',
                                                        background: '#5c6bc0',
                                                        color: 'white',
                                                        padding: '0px 5px',
                                                        borderRadius: '5px',
                                                    }}
                                                >
                                                    <PaymentsIcon sx={{ mr: 0.5 }} />
                                                    Pyt Advice
                                                </Typography>
                                            </Link>
                                        )}
                                        {Mode === "view" && (
                                            <Typography
                                                to="#"
                                                onClick={isSubmitted ? handleEmailSentLink : undefined}
                                                sx={{
                                                    padding: '0px 10px', textDecoration: 'none',
                                                    cursor: isSubmitted ? 'pointer' : 'default',
                                                    opacity: isSubmitted ? 1 : 0.5,
                                                    pointerEvents: isSubmitted ? 'auto' : 'none'

                                                }}
                                            >
                                                <Typography sx={{
                                                    display: 'flex',
                                                    background: '#4caf50',
                                                    padding: '0px 5px',
                                                    borderRadius: '5px',
                                                    color: 'white'
                                                }}> <InsertLinkIcon
                                                        sx={{
                                                            mr: 0.5,

                                                        }}
                                                    />
                                                    Send Deposit Link
                                                </Typography>
                                            </Typography>
                                        )}
                                        {Mode === "view" && (
                                            <Typography
                                                to="#"
                                                onClick={isSubmitted ? handleBookingHistoryClick : undefined}
                                                sx={{
                                                    textDecoration: 'none',
                                                    cursor: isSubmitted ? 'pointer' : 'default',
                                                    opacity: isSubmitted ? 1 : 0.5,
                                                }}
                                            >
                                                <Typography sx={{
                                                    display: 'flex',
                                                    background: '#7d8382',
                                                    color: 'white',
                                                    padding: '0px 5px',
                                                    borderRadius: '5px',
                                                }}

                                                >  <HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />  Booking History </Typography>
                                            </Typography>
                                        )}
                                        <Typography
                                            to="#"
                                            onClick={handleClickCancelBooking}
                                            sx={{ textDecoration: 'none', cursor: 'pointer' }}
                                        >
                                            {/* {Mode === "view" && TransactionData[0]?.BookSt === "B" ? "Booking Cancel" : Mode === "view" && TransactionData[0]?.BookSt === "X" ? "Booking Restore " : ""} */}
                                            <Typography
                                                sx={{
                                                    display: 'flex',
                                                    background: '#ed453c',
                                                    color: 'white',
                                                    padding: '0px 5px',
                                                    borderRadius: '5px',
                                                    marginLeft: '10px'
                                                }}
                                            >
                                                {Mode === "view" && TransactionData[0]?.BookSt === "B" ? (
                                                    <>
                                                        <CancelIcon fontSize="small" sx={{
                                                            mr: 0.5,

                                                        }} /> Booking Cancel
                                                    </>
                                                ) : Mode === "view" && TransactionData[0]?.BookSt === "X" ? (
                                                    <>
                                                        <RestoreIcon fontSize="small" sx={{
                                                            mr: 0.5,

                                                        }} /> Booking Restore
                                                    </>
                                                ) : null}
                                            </Typography>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4} >
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label">
                                        <span>
                                            Property List    <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="PropId"
                                        name="PropId"
                                        value={watch('PropId') || ''}
                                        className="custom-textfield"

                                        {...register('PropId')}
                                        onChange={handlePropertyChange}
                                        disabled={isSubmitting}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200, // Set the maximum height for the dropdown menu
                                                    overflow: "auto", // Allow scrolling if content exceeds the max height
                                                },
                                            },
                                        }}
                                    >
                                        {PropertyDrp.length > 0 && PropertyDrp?.map((type) => (
                                            <MenuItem key={type.Id} value={type.Id}>
                                                {type.Name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl variant="outlined" fullWidth>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <div
                                                    style={{
                                                        width: 25,
                                                        height: 15,
                                                        backgroundImage: `url(${selectedImage})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                />
                                            </InputAdornment>
                                        }
                                        aria-describedby="outlined-weight-helper-text"
                                        style={{ width: "100%", height: 40 }}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            // style: { height: 40 },
                                        }}
                                        placeholder={`Enter Valid ${MobDigit} digit Mobile Number`}
                                        onChange={(e) => { handleMobileChange(e, "add") }}
                                        value={watch('MobileNo') || mobileNoFromQuery || ''}
                                    // disabled={Mode === "view" ? true : !AllDisUnable ? true : false}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <DatePicker
                                    label="Booking Date"
                                    value={dayjs(watch('BookDt'))}
                                    // onChange={(newValue) => {
                                    //     setValue('BookDt', newValue ? newValue.format("YYYY-MM-DD") : "");
                                    // }}
                                    onChange={(newValue) => {
                                        const dateStr = newValue ? newValue.format("YYYY-MM-DD") : "";
                                        setValue('BookDt', dateStr);
                                        setValue('BookDtFrom', dateStr);
                                    }}
                                    disabled={isSubmitting}
                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    variant="filled"
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}
                                />
                            </Grid>
                            {/* Name Field */}
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="BookNo"
                                    name="BookNo"
                                    label="Booking No"
                                    variant="filled"
                                    fullWidth
                                    value={watch('BookNo') || ''}
                                    className="custom-textfield"
                                    {...register('BookNo')}
                                    disabled={isSubmitting}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} sm={2}  >
                                <TextField
                                    id="FirstName"
                                    name="FirstName"
                                    label="First Name"
                                    variant="filled"
                                    fullWidth
                                    value={watch('FirstName') || ''}
                                    className="custom-textfield"
                                    {...register('FirstName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={2} >
                                <TextField
                                    id="LastName"
                                    name="LastName"
                                    label="Last Name"
                                    variant="filled"
                                    fullWidth
                                    value={watch('LastName') || ''}
                                    className="custom-textfield"
                                    {...register('LastName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="Email"
                                    name="Email"
                                    label="Email"
                                    variant="filled"
                                    fullWidth
                                    value={watch('Email') || ''}
                                    className="custom-textfield"
                                    {...register('Email')}
                                    disabled={isSubmitting}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="BookRef"
                                    name="BookRef"
                                    label="Referred By"
                                    variant="filled"
                                    fullWidth
                                    value={watch('BookRef') || ''}
                                    className="custom-textfield"
                                    {...register('BookRef')}
                                // disabled={!AllDisUnable}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <DatePicker
                                    label="Booking From"
                                    value={dayjs(watch('BookDtFrom'))}
                                    //   value={dayjs()}
                                    // onChange={(newValue) => {
                                    //     setValue('BookDtFrom', newValue ? newValue.format("YYYY-MM-DD") : "");
                                    // }}
                                    onChange={(newValue) => {
                                        const dateStr = newValue ? newValue.format("YYYY-MM-DD") : "";
                                        setValue('BookDtFrom', dateStr);
                                    }}
                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    disabled={isSubmitting}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="Duration"
                                    name="Duration"
                                    label={
                                        <span>
                                            Duration <span style={{ color: "red" }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    value={watch('Duration') || ''}
                                    className="custom-textfield"
                                    {...register('Duration')}
                                    onChange={handlePropertyChange}
                                    disabled={isSubmitting}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <DatePicker
                                    label="Booking Up To"
                                    value={dayjs(watch('BookUpToDt')).subtract(1, 'day') || dayjs()}
                                    onChange={(newValue) => {
                                        setValue('BookUpToDt', newValue ? newValue.format("YYYY-MM-DD") : "");
                                    }}
                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    disabled={true}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <DatePicker
                                    label="Checkout Date"
                                    // value={dayjs(watch('CheckoutDt') || dayjs())}
                                    value={dayjs(watch('CheckoutDt')).subtract(1, 'day')}
                                    onChange={(newValue) => {
                                        const dateValue = newValue ? newValue.format("YYYY-MM-DD") : "";
                                        setValue('CheckoutDt', dateValue);
                                        setBillFunc();
                                    }}
                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    disabled={!AllDisUnable}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sx={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center' }}>
                                <Button variant="contained" size="medium"
                                    sx={{
                                        backgroundColor: "#635bff",
                                        height: 35,
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                    }}
                                    // onClick={handleClickCheckAva}
                                    onClick={handleClickCheckAvaCal}
                                // disabled={!AllDisUnable}
                                >
                                    Check Availability
                                </Button>
                            </Grid>

                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="WingName"
                                    name="WingName"
                                    label="Wing"
                                    variant="filled"
                                    fullWidth
                                    value={watch('WingName') || ''}
                                    className="custom-textfield"
                                    {...register('WingName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="FloorName"
                                    name="FloorName"
                                    label="Floor"
                                    variant="filled"
                                    fullWidth
                                    value={watch('FloorName') || ''}
                                    className="custom-textfield"
                                    {...register('FloorName')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="RoomTypeName"
                                    name="RoomTypeName"
                                    label="Room Type"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoomTypeName') || ''}
                                    className="custom-textfield"
                                    {...register('RoomTypeName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="RoomViewNAme"
                                    name="RoomViewNAme"
                                    label="View"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoomViewNAme') || ''}
                                    className="custom-textfield"
                                    {...register('RoomViewNAme')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="RoomBedTypeName"
                                    name="RoomBedTypeName"
                                    label="Bed Type"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoomBedTypeName') || ''}
                                    className="custom-textfield"
                                    {...register('RoomBedTypeName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="RoombedName"
                                    name="RoombedName"
                                    label="Bed No"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoombedName') || ''}
                                    className="custom-textfield"
                                    {...register('RoombedName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="BedRent"
                                    name="BedRent"
                                    label="Standard Rent"
                                    variant="filled"
                                    fullWidth
                                    value={watch('BedRent') || ''}
                                    className="custom-textfield"
                                    {...register('BedRent')}
                                    // disabled={true}
                                    disabled={isSubmitting}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label"> Payment Plan <span style={{ color: 'red' }}>*</span> </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="RoomPlanId"
                                        name="RoomPlanId"
                                        value={watch('RoomPlanId') || ''}
                                        className="custom-textfield"
                                        {...register('RoomPlanId')}
                                        onChange={(e) => handlePlanChange(e.target.value)}
                                        disabled={isSubmitting}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    overflow: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        {PlanDrp?.map((type) => (
                                            <MenuItem key={type.RoomPlanID} value={type.RoomPlanID}>
                                                {type.PlanName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="PlanTenur"
                                    name="PlanTenur"
                                    label="Tenure"
                                    variant="filled"
                                    fullWidth
                                    value={watch('PlanTenur')}
                                    className="custom-textfield"
                                    {...register('PlanTenur')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="FreeMonth"
                                    name="FreeMonth"
                                    label="FreeMonth"
                                    variant="filled"
                                    fullWidth
                                    value={watch('FreeMonth')}
                                    className="custom-textfield"
                                    {...register('FreeMonth')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="LastAdjMonths"
                                    name="LastAdjMonths"
                                    label="MinAdvMonth"
                                    variant="filled"
                                    fullWidth
                                    value={watch('LastAdjMonths')}
                                    className="custom-textfield"
                                    {...register('LastAdjMonths')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="IncRentPerc"
                                    name="IncRentPerc"
                                    label="Increase (%)"
                                    variant="filled"
                                    fullWidth
                                    value={watch('IncRentPerc')}
                                    className="custom-textfield"
                                    {...register('IncRentPerc')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="DepositAmt"
                                    name="DepositAmt"
                                    label="Deposit"
                                    variant="filled"
                                    fullWidth
                                    value={watch('DepositAmt')}
                                    className="custom-textfield"
                                    {...register('DepositAmt')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="CouponNo"
                                    name="CouponNo"
                                    label="Coupon"
                                    variant="filled"
                                    fullWidth
                                    value={watch('CouponNo') || ''}
                                    className="custom-textfield"
                                    {...register('CouponNo')}
                                    disabled={isSubmitting}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2}>
                                <TextField
                                    id="DiscType"
                                    name="DiscType"
                                    label="Discount Type"
                                    variant="filled"
                                    fullWidth
                                    value={(() => {
                                        const discType = watch('DiscType');
                                        const amtDiscount = watch('AMTDISCOUNT');

                                        if (discType === "F") {
                                            return amtDiscount === undefined ? 'FreeMonth (0)' : `FreeMonth (${amtDiscount})`;
                                        } else if (discType === "M") {
                                            return amtDiscount === undefined ? 'Monthly (0)' : `Monthly (${amtDiscount})`;
                                        } else if (discType === "L") {
                                            return "LumpSum";
                                        }
                                        return '';
                                    })()}
                                    className="custom-textfield"
                                    {...register('DiscType')}
                                // disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="DiscAmt"
                                    name="DiscAmt"
                                    label="Discount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('DiscAmt')}
                                    className="custom-textfield"
                                    {...register('DiscAmt')}
                                    disabled={isSubmitting}
                                />
                            </Grid>
                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="TotalRent"
                                    name="TotalRent"
                                    label="Total Rent"
                                    variant="filled"
                                    fullWidth
                                    value={watch('TotalRent')}
                                    {...register('TotalRent')}
                                    className="custom-textfield"
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="NetAmt"
                                    name="NetAmt"
                                    label="Net Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('NetAmt')}
                                    className="custom-textfield"
                                    {...register('NetAmt')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="MonthlyAmt"
                                    name="MonthlyAmt"
                                    label="Effective Rent "
                                    variant="filled"
                                    fullWidth
                                    value={watch('MonthlyAmt')}
                                    {...register('MonthlyAmt')}
                                    className="custom-textfield"
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="AdvcRcble"
                                    name="AdvcRcble"
                                    label="Net Payable"
                                    variant="filled"
                                    fullWidth
                                    value={watch('AdvcRcble')}
                                    {...register('AdvcRcble')}
                                    className="custom-textfield"
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label">
                                        <span>
                                            Bill Cycle    <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="BillCycle"
                                        name="BillCycle"
                                        value={watch('BillCycle') || ''}
                                        className="custom-textfield"
                                        {...register('BillCycle')}
                                        disabled={isSubmitting}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    overflow: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem key="F" value="F">
                                            First
                                        </MenuItem>
                                        <MenuItem key="S" value="S">
                                            Second
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={1}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label">
                                        <span>
                                            TopUp Days  <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="Topupdays"
                                        name="TopupId"
                                        value={watch('TopupId') || ''}
                                        className="custom-textfield"
                                        {...register('TopupId')}
                                        onChange={handleTopUpChange}
                                        disabled={isSubmitting}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    overflow: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        {TopUpDrp.length > 0 && TopUpDrp?.map((type) => (
                                            <MenuItem key={type.TopupID} value={type.TopupID}>
                                                {type.Topupdays}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="TopupAmt"
                                    name="TopupAmt"
                                    label="TopUp Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('TopupAmt') || ''}
                                    className="custom-textfield"
                                    {...register('TopupAmt')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="TransPlanId-select-label"> AddOn1 </InputLabel>
                                    <Select
                                        labelId="TransPlanId-select-label"
                                        id="TransPlanId"
                                        name="TransPlanId"
                                        value={watch('TransPlanId') || ''}
                                        className="custom-textfield"
                                        {...register('TransPlanId')}
                                        onChange={handleTopUpChange}
                                        disabled={isSubmitting}
                                    >
                                        {TransPlanDrp?.map((type) => (
                                            <MenuItem key={type.Id} value={type.Id}>
                                                {type.TransPlanName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="TrspChrg"
                                    name="TrspChrg"
                                    label="Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('TrspChrg')}
                                    className="custom-textfield"
                                    {...register('TrspChrg')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="MessPlanId-select-label">AddOn2</InputLabel>
                                    <Select
                                        labelId="MessPlanId-select-label"
                                        id="MessPlanId"
                                        name="MessPlanId"
                                        value={watch('MessPlanId') || ''}
                                        className="custom-textfield"
                                        {...register('MessPlanId')}
                                        disabled={isSubmitting}
                                        onChange={handleTopUpChange}
                                    >
                                        {MessPlanDrp?.map((type) => (
                                            <MenuItem key={type.MessPlanID} value={type.MessPlanID}>
                                                {type.MessPlanName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="MessChrg"
                                    name="MessChrg"
                                    label="Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('MessChrg')}
                                    className="custom-textfield"
                                    {...register('MessChrg')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={4}>
                                <TextField
                                    fullWidth
                                    label="Remark"
                                    name="BookRemark"
                                    multiline
                                    rows={1}
                                    variant="filled"
                                    className="custom-textfield"
                                    value={watch('BookRemark') || ''}
                                    // disabled={!AllDisUnable}
                                    {...register('BookRemark')}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: "60px",

                                            display: "flex",
                                            alignItems: "center",
                                            padding: "12px",
                                        },
                                        "& .MuiInputBase-input": {
                                            resize: "vertical",
                                            padding: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                        "& .MuiFilledInput-root": {
                                            "&:hover": {
                                                backgroundColor: "transparent",
                                            },
                                            "&.Mui-focused": {
                                                backgroundColor: "transparent",
                                            },
                                        },
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} sm={2} >
                                <FormControl variant="outlined" fullWidth>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"

                                        startAdornment={
                                            <InputAdornment position="start" sx={{ width: 'auto', padding: '0 -30px' }}>
                                                <CurrencyRupeeIcon />
                                            </InputAdornment>
                                        }
                                        aria-describedby="outlined-weight-helper-text"
                                        style={{
                                            width: '100%',
                                            height: 40,
                                            maxWidth: '100%',
                                            overflow: 'hidden',
                                            // textOverflow: 'ellipsis', // Shows ellipsis if content exceeds input width

                                        }}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            style: {
                                                height: 50,
                                                padding: '12px 14px',
                                                fontSize: fontSize,
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis', // Truncate overflowed content with ellipsis
                                            },
                                        }}
                                        {...register("AmtInWor")}

                                        value={watch('AmtInWor') || ''}
                                        disabled={true}
                                        // disabled={Mode === "view" ? true : !AllDisUnable ? true : false}
                                        readOnly
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="TotNetAmt"
                                    name="TotNetAmt"
                                    label="Total Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch("TotNetAmt")}
                                    className="custom-textfield"
                                    {...register('TotNetAmt')}
                                    disabled={true}

                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        <Tooltip title="View Billing Details">
                            <span>
                                <Button variant="contained" size="small"
                                    sx={{
                                        backgroundColor: "#635bff",
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        mr: 1
                                    }}
                                    onClick={handleBillingDetails}
                                // disabled={""}
                                >
                                    Acc Details
                                </Button>
                            </span>
                        </Tooltip>

                        <Tooltip>
                            <span>
                                <Button variant="contained" size="small"
                                    sx={{
                                        backgroundColor: "#635bff",
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        mr: 1,
                                        cursor: isSubmitted ? 'pointer' : 'default',
                                        opacity: isSubmitted ? 1 : 0.5,
                                    }}
                                    onClick={isSubmitted ? handleAccountGenerateClick : undefined}
                                // disabled={BookId === -1 || !isBookingConfirmed}
                                >
                                    Acc Gen
                                </Button>
                            </span>
                        </Tooltip>

                        <Button variant="contained" size="small"
                            sx={{
                                mr: 1,
                                background: 'linear-gradient(290deg, #668bb3, #426c92)'
                            }}
                            onClick={handleSubmitClick}
                            // disabled={!AllDisUnable}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitted...' : 'Submit'}
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                mr: 1,
                                background: 'linear-gradient(290deg, #5e84ad, #4679a5)'
                            }}
                            disabled={!AllDisUnable}
                            onClick={handleCancelClick}
                        >
                            Cancel
                        </Button>
                    </Grid>

                </Grid>
                <div style={{ display: 'none' }}>
                    {<BReport contentRef={contentRef} DataObj={watch()} />}
                </div>
                <Dialog
                    open={openRenewalPopup}
                    onClose={() => {
                        setOpenRenewalPopup(false);
                        setRenewalData(null);
                    }}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px 24px'
                    }}>
                        Previous Booking Details
                        <Button
                            onClick={() => setOpenRenewalPopup(false)}
                            sx={{
                                minWidth: 'auto',
                                padding: '4px',
                                backgroundColor: '#1976d2',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                }
                            }}
                        >
                            Close
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        {renewalData ? (
                            <TableContainer>
                                <Table sx={{
                                    '& .MuiTableCell-root': {
                                        padding: 0,
                                        border: '1px solid rgba(224, 224, 224, 1)'
                                    }
                                }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Booking No</TableCell>
                                            <TableCell>Check-In Date</TableCell>
                                            <TableCell>Check-Out Date</TableCell>
                                            <TableCell>Unit</TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {renewalData.map((booking, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{booking.BookNo}</TableCell>
                                                <TableCell>
                                                    {moment(booking.BookDtFrom).format("DD-MM-YYYY")}
                                                </TableCell>
                                                <TableCell>
                                                    {moment(booking.BookUpToDt).format("DD-MM-YYYY")}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.RoomBedName}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.ResidentName}
                                                </TableCell>
                                                <TableCell>{booking.BookStatus}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Typography>No previous bookings found</Typography>
                        )}
                    </DialogContent>
                </Dialog>

                <RoomSelection
                    open={OpenHistoryTable}
                    onClose={handleCloseRoom}
                    propId={PropId}
                    dateFrom={DateFrom.format('YYYY-MM-DD')}
                    dateTo={DateTo.format('YYYY-MM-DD')}
                    onRoomSelect={handleRowDoubleClick}
                    defaultSearchValue={selectedBedData?.RoombedName}
                />
            </Box>
        </LocalizationProvider>
    );
};

export default Renewbooking;

